import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { ModalService } from '../../../lib/modal.service';
import { ApiService } from '../../../lib/api.service';
import { LogService } from '../../../lib/log.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

import * as _ from 'lodash';

@Component({
    selector: 'org-auth-component',
    templateUrl: './org-auth.component.html',
    styleUrls: ['./org-auth.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class OrgAuthComponent implements OnInit {
  isLoaded = false;
  orgAuth: any;
  title = 'Edit SSO Configuration';

  constructor(
    private modalService: ModalService,
    private apiService: ApiService,
    private logService: LogService,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location) {
  }

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');
    this.apiService.get('admin/organizationsauth').subscribe(
      (results: any) => {
        const authList = results.data;
        this.orgAuth = _.find(authList, { ID: parseInt(id, 10) });
        if (this.orgAuth) {
          this.title = 'SSO Configuration for ' + this.orgAuth.Name;
        }
        this.isLoaded = true;
      },
      (error: any) => {
        this.logService.error('Error loading auth config. ' + error.message);
        this.isLoaded = true;
      }
    );
  }

  doSave() {
    this.apiService.post('admin/orgauthsave', { orgAuth: this.orgAuth }).subscribe(
      (result: any) => {
        this.modalService.showAlert('Success', 'The authorization configuration has been saved.');
        this.router.navigate(['/admin/organization-listing']);
      },
      (error: any) => {
        this.logService.error('Error saving configuration. ' + error.message);
      }
    );
  }

  onClose() {
    this.location.back();
  }
}
